import React, { useState } from "react";
import ItemCard from "@/components/handover/ItemCard";
import { Button } from "@/components/ui/button";
import { apiAddItem, formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Plus } from "lucide-react";

export default function CategorySection({
    category,
    label,
    items,
    handoverId,
    canEdit,
    onItemAdded,
    onItemChanged,
    onItemRemoved,
}) {
    const [adding, setAdding] = useState(false);

    async function addItem() {
        setAdding(true);
        try {
            const created = await apiAddItem(handoverId, {
                category: category,
                title: "New item",
                details: "",
                priority: category === "Open Incident" ? "P3" : "Not applicable",
                item_status: "Open",
                carry_forward: false,
            });
            onItemAdded?.(created);
        } catch (err) {
            toast.error(formatApiError(err));
        } finally {
            setAdding(false);
        }
    }

    return (
        <section
            data-testid={`section-${category.replace(/\s+/g, "-").toLowerCase()}`}
            className="scroll-mt-16"
        >
            <div className="flex items-baseline justify-between mb-2">
                <h2 className="text-[15px] font-semibold text-[#070F26] flex items-center gap-2">
                    {label}
                    <span
                        data-testid={`section-count-${category.replace(/\s+/g, "-").toLowerCase()}`}
                        className="text-[11px] font-medium text-ntt-muted bg-[#F4F6F9] rounded-full h-5 px-2 inline-flex items-center"
                    >
                        {items.length}
                    </span>
                </h2>
                {canEdit && (
                    <Button
                        variant="outline"
                        size="sm"
                        onClick={addItem}
                        disabled={adding}
                        data-testid={`add-item-${category.replace(/\s+/g, "-").toLowerCase()}`}
                        className="h-8 text-[12px]"
                    >
                        <Plus className="h-3.5 w-3.5 mr-1" />
                        Add item
                    </Button>
                )}
            </div>
            {items.length === 0 ? (
                <div className="text-[12px] text-ntt-muted italic border border-dashed border-ntt-border rounded-md px-3 py-4 text-center">
                    Nothing here.
                </div>
            ) : (
                <div className="space-y-2">
                    {items.map((it) => (
                        <ItemCard
                            key={it.item_id}
                            item={it}
                            handoverId={handoverId}
                            canEdit={canEdit}
                            onChanged={onItemChanged}
                            onRemoved={onItemRemoved}
                        />
                    ))}
                </div>
            )}
        </section>
    );
}
